const LangCards = {
	"cards._title": ["MY CARDS", "កាត​​ខ្ញុំ"],
	"cards._mySuspendedCards": ["MY SUSPENDED CARDS", "កាតខ្ញុំ​ដែល​បាន​បិទ​"],
	"cards._addCard": ["(+) Add Card", "(+) បន្ថែម​កាត"],
}

export default LangCards



// WEBPACK FOOTER //
// ./src/resources/pages/LangCards.js